// The $120 disposal bundle includes the standalone $45 box-breakdown work.
// Normalize legacy requests containing both IDs without changing saved quotes.
export const normalizeOptionalAddons = (values = []) => {
  const unique = [...new Set(values || [])];
  return unique.includes('disposal-service')
    ? unique.filter(id => id !== 'cardboard-removal')
    : unique;
};

export const toggleOptionalAddon = (values, id) => {
  const current = normalizeOptionalAddons(values);
  if (current.includes(id)) return current.filter(value => value !== id);
  const alternatives = ['cardboard-removal', 'disposal-service'];
  const next = alternatives.includes(id)
    ? current.filter(value => !alternatives.includes(value))
    : current;
  return normalizeOptionalAddons([...next, id]);
};
